import { AlertTriangle } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Sticky top banner shown only when the current firm is suspended.
 *
 * Suspended firms have all writes blocked by the backend (`auth.py:get_current_ctx`).
 * Without this banner, users see toast errors on every action with no context.
 * Super-admins are exempt from suspension (they can still log in to fix things).
 */
export default function SuspendedBanner() {
  const { firm, isSuperAdmin } = useAuth();
  if (!firm?.suspended) return null;
  if (isSuperAdmin) return null;

  return (
    <div
      className="w-full bg-red-600 text-white px-6 py-2.5 flex items-center justify-center gap-3 text-sm shadow-md"
      data-testid="suspended-banner"
      role="alert"
    >
      <AlertTriangle className="w-4 h-4 shrink-0" />
      <span>
        <strong>Workspace suspended.</strong> All edits, drafts and downloads are read-only. Please contact your platform administrator to restore access.
      </span>
    </div>
  );
}
